module.exports = __webpack_public_path__ + "img/icon-track-light.653605bb.svg";